<div class="d-flex justify-content-end flex-wrap mb-3 add-spray-btn">
  <button type="button" class="btn btn-success" (click)="addSprayEvent()">+ Add spray event</button>
</div>

<app-vertical-tab-group [stacked]="false">
  <app-vertical-tab *ngFor="let sprayStudy of sprayBoothStudy.controls; let i = index" [title]="'Spray ' + (i + 1)"
    [hasError]="sprayStudy.invalid">

    <div [formGroup]="sprayStudy" class="px-2 px-md-3">

      <!-- Volume + Timepoint -->
      <div class="row">
        <div class="col-6 col-md-3 mb-3">
          <div [class.has-error]="applicationVolumeId(i).invalid" class="">
            <label class="form-label">
              Application Volume:
            </label>
            <select formControlName="applicationVolumeId" class="form-control">
              <option *ngFor="let option of sprayStudyOptions.applicationVolumes" [ngValue]="option.id">
                {{ option.display }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-6 col-md-3 mb-3">
          <div class="" [class.has-error]="applicationTimepointId(i).invalid">
            <label class="form-label">
              Application Timepoint:
            </label>
            <select formControlName="applicationTimepointId" class="form-control">
              <option *ngFor="let option of sprayStudyOptions.applicationTimepoints" [ngValue]="option.id">
                {{ option.display }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div *ngIf="sprayStudy.errors?.noActiveOrAdjuvant"
        class="text-danger text-center row mt-2">
        At least one Active or Adjuvant is required.
      </div>
      <div class="row">
        <!-- Actives -->
        <div class="col-12 col-lg-8 mb-4">
          <h5>Actives</h5>
          <div class="table-responsive">
            <table class="table table-striped table-bordered align-middle">
              <thead class="table-dark">
                <tr>
                  <th></th>
                  <th>Herbicide Trade Name</th>
                  <th>Active Ingredient</th>
                  <th>Conc. Value</th>
                  <th>Conc. Units</th>
                  <th>Rate Value</th>
                  <th>Rate Unit</th>
                  <th>Relative Field Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let active of getActive(i).controls; let j = index" [formGroup]="active">
                  <td>
                    <button type="button" class="btn btn-sm btn-danger" (click)="removeActive(i, j)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                  <td>
                    <div [class.has-error]="activeId(i, j).invalid">
                      <select (change)="onTradeNameChange($event.target.value, i, j, k)" formControlName="activeId" class="form-control trade-name-width">
                        <option *ngFor="let option of sprayStudyOptions.herbicideTradeNames" [value]="option.id">
                          {{ option.display }}
                        </option>
                      </select>
                    </div>
                  </td>
                  <td>{{ getDisplayIngredient(i, j) }}</td>
                  <td>{{ getDisplayConcentrationValue(i, j) }}</td>
                  <td>{{ getDisplayConcentrationUnit(i, j) }}</td>
                  <td>
                    <div [class.has-error]="getRateValue(i, j).invalid">
                      <input type="text" class="form-control number-width" formControlName="rateValue"/>
                      <div [class.has-error]="getRateValue(i, j).invalid" class="text-danger">
                        <small *ngIf="getRateValue(i, j).errors?.pattern">Maximum 10 digits before and 10 digits after the decimal allowed.</small>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div [class.has-error]="getRateUnitId(i, j).invalid">
                      <select formControlName="rateUnitId" class="form-control field-width">
                        <option *ngFor="let option of sprayStudyOptions.rateUnits" [ngValue]="option.id">
                          {{ option.display }}
                        </option>
                      </select>
                    </div>
                  </td>
                  <td>
                    <div [class.has-error]="getRelativeFieldRate(i, j).invalid" class="flex-row">
                      <input type="text" class="form-control number-width" formControlName="relativeFieldRate" />
                      <span class="x-label">x</span>
                      <div [class.has-error]="getRelativeFieldRate(i, j).invalid" class="text-danger">
                        <small *ngIf="getRelativeFieldRate(i, j).errors?.pattern">Maximum 10 digits before and 10 digits after the decimal allowed.</small>
                      </div>
                    </div>
                  </td>
                  </tr>
              </tbody>
            </table>
            <div class="text-end">
              <button type="button" class="btn btn-sm btn-primary" (click)="addActive(i)">
                + Add Active
              </button>
            </div>
          </div>
        </div>

        <!-- Adjuvants -->
        <div class="col-12 col-lg-4 mb-4">
          <h5>Adjuvants</h5>
          <div class="table-responsive">
            <table class="table table-striped table-bordered align-middle">
              <thead class="table-light">
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Value</th>
                  <th>Unit</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let adjuvant of getAdjuvant(i).controls; let j = index" [formGroup]="adjuvant">
                  <td>
                    <button type="button" class="btn btn-sm btn-danger" (click)="removeAdjuvant(i, j)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                  <td>
                    <div [class.has-error]="getAdjuvantId(i, j).invalid">
                      <select formControlName="adjuvantId" class="form-control field-width">
                        <option *ngFor="let option of sprayStudyOptions.adjuvantNames" [ngValue]="option.id">
                          {{ option.display }}
                        </option>
                      </select>
                    </div>
                  </td>
                  <td>
                    <div [class.has-error]="getAdjuvantValue(i, j).invalid">
                      <input type="text" class="form-control number-width" formControlName="adjuvantValue"/>
                      <div [class.has-error]="getAdjuvantValue(i, j).invalid" class="text-danger">
                        <small *ngIf="getAdjuvantValue(i, j).errors?.pattern">Maximum 10 digits before and 10 digits after the decimal allowed.</small>
                      </div>
                    </div>
                  </td>
                  <td>{{ getDisplayAdjuvantUnit(i, j) }}</td>
                </tr>
              </tbody>
            </table>
            <div class="text-end">
              <button type="button" class="btn btn-sm btn-primary" (click)="addAdjuvant(i)">
                + Add Adjuvant
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end mt-7">
        <button type="button" class="btn btn-sm btn-danger" [disabled]="sprayBoothStudy.length <= 1"  (click)="deleteSprayEvent(i)">
          - Remove Spray Event
        </button>
      </div>
    </div>
  </app-vertical-tab>
</app-vertical-tab-group>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/spray-booth-study/spray-booth-study-form/spray-booth-study-form.component.html